import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { RepresentativeContactModel } from 'hx-services';
import { Injectable } from '@angular/core';

@Injectable({providedIn: 'root'})
export class StorageService {

  constructor(
    private http: HttpClient,
  ) { }

  getSupplier(supplierId: number): Observable<any> {
    return this.http.get(`/api/vn/suppliers/${supplierId}`);
  }

  deleteRepresentative(supplierId: number, representativeId: number): Observable<any> {
    return this.http.delete(`/api/vn/suppliers/${supplierId}/representatives/${representativeId}`);
  }

  deleteRepresentativeContact(supplierId: number, representativeId: number, contactId): Observable<RepresentativeContactModel> {
    return this.http.delete<RepresentativeContactModel>(`/api/vn/suppliers/${supplierId}/representatives/${representativeId}/contacts/${contactId}`);
  }

  updateRepresentativeContact(id: number, representativeId: number, contactId: number, body: any): Observable<RepresentativeContactModel> {
    return this.http.put<RepresentativeContactModel>(`/api/vn/suppliers/${id}/representatives/${representativeId}/contacts/${contactId}`, body);
  }

  createRepresentativeContact(id: number, representativeId: number, body: {value: string, type: string}[]): Observable<RepresentativeContactModel> {
    return this.http.post<RepresentativeContactModel>(`/api/vn/suppliers/${id}/representatives/${representativeId}/contacts`, body);
  }

  updateRepresentative(id: number, representativeId: number, body: any): Observable<any> {
    return this.http.put(`/api/vn/suppliers/${id}/representatives/${representativeId}`, body);
  }

  createRepresentative(id: number, body: any): Observable<any> {
    return this.http.post(`/api/vn/suppliers/${id}/representatives`, body);
  }
}
